module.exports = __webpack_public_path__ + "static/media/logo_microsite_en.631af5a6.png";